export default __webpack_public_path__ + "static/media/period.73201a34.svg";